<template>
  <public-forgot-password-template
    v-model:email="data.email"
    :error="data.error"
    @submit="submit"
    @alert-close="data.error = ''" />
</template>

<script>
export default {
  name: 'PublicForgotPassword',
};
</script>

<script setup>
import { reactive } from 'vue';
import { useStore } from "vuex";

import PublicForgotPasswordTemplate from '../../templates/PublicForgotPassword';

const store = useStore();

const data = reactive({
  email: "",
  error: "",
});

const submit = async () => {
  try {
    await store.dispatch('forgotPassword', { email: data.email });
  } catch (e) {
    try {
      const { response: { data: { error: { message } } } } = e;
      data.error = message;
    } catch {
      data.error = 'Unknown error message from the server. Please contact our support team.';
    }
  }
};
</script>
